var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 341.67,
    style: {
      fill: "#FF4B55"
    },
    width: 170.33,
    height: 512
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.33,
    style: {
      fill: "#FFE15A"
    },
    width: 171.33,
    height: 512
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#73AF00"
    },
    width: 170.33,
    height: 512
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMl);
export default __webpack_public_path__ + "static/media/ml.d7b98c0348bf104d860a8b491fcb7468.svg";
export { ForwardRef as ReactComponent };